<template>
  <div class="slo-auth-password-check">
    <p class="text-sm">
      {{ 'Password must be 8 characters minimum with a mix of lowercase, uppercase, and alphanumeric characters.' | t }}
    </p>
    <div class="mt-md">
      <p class="password-check" :class="{passed: $v.password.containsUppercase}">
        <span class="circle">
          <SloIcon name="Check" />
        </span>
        {{ 'One uppercase character' | t }}
      </p>
      <p class="password-check" :class="{passed: $v.password.containsLowercase}">
        <span class="circle">
          <SloIcon name="Check" />
        </span>
        {{ 'One lowercase character' | t }}
      </p>
      <p class="password-check" :class="{passed: $v.password.containsNumber}">
        <span class="circle">
          <SloIcon name="Check" />
        </span>
        {{ 'One number' | t }}
      </p>
      <p class="password-check" :class="{passed: $v.password.minLength && $v.password.required}">
        <span class="circle">
          <SloIcon name="Check" />
        </span>
        {{ '8 characters minimum' | t }}
      </p>
    </div>
  </div>
</template>

<script>
import {minLength, required, sameAs} from 'vuelidate/lib/validators';
import t from '../../js/main/i18n';
import SloIcon from './SloIcon.vue';

export default {
  name: 'SloPasswordValidation',
  components: {
    SloIcon
  },
  filters: {
    t
  },
  props: {
    password: {type: String, required: true},
    confirmPassword: {type: String, required: true}
  },
  created() {
    return this.$v.$touch();
  },
  watch: {
    password() {
      this.$emit('status', this.getStatus());
    },
    confirmPassword() {
      this.$emit('status', this.getStatus());
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      containsUppercase: function(value) {return /[A-Z]/.test(value);},
      containsLowercase: function(value) {return /[a-z]/.test(value);},
      containsNumber: function(value) {return /[0-9]/.test(value);}
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  methods: {
    getStatus() {
      return {
        password: !this.$v.password.$invalid,
        confirmPassword: !this.$v.confirmPassword.$invalid
      };
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.password-check {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  color: $color-gray-700;

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background-color: transparent;
    border: 1px solid $color-gray-800;
    border-radius: 9999px;
    transition: background-color 0.2s ease-in, border-color 0.2s ease-in;

    .slo-icon {
      transform: scale(0);
      transform-origin: center;
      transition: transform 0.15s linear;
    }
  }

  &.passed {
    color: $color-gray-900;

    .circle {
      background-color: $color-green-400;
      border-color: $color-green-400;

      .slo-icon {
        color: $color-white;
        transform: scale(0.65);
        transition: transform 0.2s 0.05s linear;
      }
    }
  }
}
</style>
